// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.game-wrapper {
  text-align: center;
  font-family: Arial;
  padding: 20px;
}

.grid {
  display: grid;
  grid-template-columns: repeat(4, 80px);
  gap: 12px;
  justify-content: center;
  margin-top: 20px;
}

.card {
  width: 80px;
  height: 80px;
  perspective: 800px;
  cursor: pointer;
}

.inner {
  width: 100%;
  height: 100%;
  position: relative;
  transition: transform 0.5s;
  transform-style: preserve-3d;
}

.card.flipped .inner {
  transform: rotateY(180deg);
}

.front,
.back {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  backface-visibility: hidden;
}

.front {
  background: #2c2c3a;
  color: white;
}

.back {
  background: #4ade80;
  transform: rotateY(180deg);
}`, "",{"version":3,"sources":["webpack://./src/features/Games/memory/memory.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,SAAS;EACT,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B","sourcesContent":[".game-wrapper {\n  text-align: center;\n  font-family: Arial;\n  padding: 20px;\n}\n\n.grid {\n  display: grid;\n  grid-template-columns: repeat(4, 80px);\n  gap: 12px;\n  justify-content: center;\n  margin-top: 20px;\n}\n\n.card {\n  width: 80px;\n  height: 80px;\n  perspective: 800px;\n  cursor: pointer;\n}\n\n.inner {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  transition: transform 0.5s;\n  transform-style: preserve-3d;\n}\n\n.card.flipped .inner {\n  transform: rotateY(180deg);\n}\n\n.front,\n.back {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 24px;\n  backface-visibility: hidden;\n}\n\n.front {\n  background: #2c2c3a;\n  color: white;\n}\n\n.back {\n  background: #4ade80;\n  transform: rotateY(180deg);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
